/*
 * @Author: Chao Yang
 * @Date: 2020-09-22 08:49:52
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-09-06 12:45:48
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataRoomEditorProxy } from 'src/app/domain/proxy/offering/data-room-editor.proxy';
import * as DataRoomEditorModel from 'src/app/domain/model/offering/editor';
import { format } from 'date-fns';

@Injectable()
export class DataRoomEditorService {
  constructor(private dataRoomEditorProxy: DataRoomEditorProxy) {}

  getMarketingFundName(marketingFundId: number): Observable<string> {
    return this.dataRoomEditorProxy.getMarketingFundName(marketingFundId);
  }

  getMarketingFundDetailPageDraft(
    marketingFundId: number
  ): Observable<DataRoomEditorModel.IDraft> {
    return this.dataRoomEditorProxy.getMarketingFundDetailPageDraft(
      marketingFundId
    );
  }

  getMarketingFundDetailPageFields(
    marketingFundId: number
  ): Observable<DataRoomEditorModel.IField[]> {
    return this.dataRoomEditorProxy.getMarketingFundDetailPageFields(
      marketingFundId
    );
  }

  getMarketingFundDetailPageUserPermission(
    marketingFundId: number
  ): Observable<boolean> {
    return this.dataRoomEditorProxy.getMarketingFundDetailPageUserPermission(
      marketingFundId
    );
  }

  publishMarketingFundDetailPageDraft(
    marketingFundId: number,
    draft: DataRoomEditorModel.IDraft
  ): Observable<number> {
    let str = JSON.stringify(draft),
      data = JSON.parse(str);
    if (draft.banner.lastModificationTime !== null) {
      data.banner.lastModificationTime = format(
        draft.banner.lastModificationTime,
        'yyyy-MM-dd'
      );
    }
    if (draft.detail.lastModificationTime !== null) {
      data.detail.lastModificationTime = format(
        draft.detail.lastModificationTime,
        'yyyy-MM-dd'
      );
    }
    if (draft.photo.lastModificationTime !== null) {
      data.photo.lastModificationTime = format(
        draft.photo.lastModificationTime,
        'yyyy-MM-dd'
      );
    }
    if (draft.video.lastModificationTime !== null) {
      data.video.lastModificationTime = format(
        draft.video.lastModificationTime,
        'yyyy-MM-dd'
      );
    }
    // if (draft.photo && draft.photo.data && draft.photo.data.length > 0) {
    //   data.photo.data.forEach(
    //     (item) => (item.uploadDate = format(item.uploadDate, 'yyyy-MM-dd'))
    //   );
    // }
    return this.dataRoomEditorProxy.publishMarketingFundDetailPageDraft(
      marketingFundId,
      data
    );
  }

  saveMarketingFundDetailPageDraft(
    marketingFundId: number,
    draft: DataRoomEditorModel.IDraft
  ): Observable<number> {
    return this.dataRoomEditorProxy.saveMarketingFundDetailPageDraft(
      marketingFundId,
      draft
    );
  }

  uploadBannerImageLink(): string {
    return this.dataRoomEditorProxy.uploadBannerImageLink();
  }

  uploadPhotoLink(): string {
    return this.dataRoomEditorProxy.uploadPhotoLink();
  }

  uploadVideoLink(): string {
    return this.dataRoomEditorProxy.uploadVideoLink();
  }

  getOfferingDetailPermission(marketingFundId: number): Observable<boolean> {
    return this.dataRoomEditorProxy.getOfferingDetailPermission(
      marketingFundId
    );
  }

  storeDraftData(
    marketingFundId: string,
    draft: DataRoomEditorModel.IDraft
  ): Observable<unknown> {
    return this.dataRoomEditorProxy.storeDraftData(marketingFundId, draft);
  }

  getDraftData(
    marketingFundId: string,
    draftId: number
  ): Observable<DataRoomEditorModel.IDraft> {
    return this.dataRoomEditorProxy.getDraftData(marketingFundId, draftId);
  }
}
